import { iconsPath, imagePath } from '../../../../utils/imagePath';

export const industries = [
  'Manufacturing & Industrial',
  'Education & Training',
  'Defence & Aerospace',
  'Healthcare & Pharma',
  'Automotive & Transportation',
  'Energy & Mining',
  'Retail & E-Commerce',
  'Architecture & Real-Estate',
  'Tourism & Hospitality',
];

export const technologies = ['AR', 'IoT', 'Blockchain', 'Projection'];

export const dataTypes = [
  'Customer Data',
  'Analytics',
  'Learning Data',
  'Operations',
  'Project Data',
  'Financial Data',
  'Visitor Data',
  'City Data',
  'Farm Data',
];

export const features = [
  {
    title: 'Immersive Interfaces',
    description:
      'Uses AR/VR/MR and smart glasses to enable natural, real-world interaction with digital objects.',
    icon: iconsPath?.ImmersiveInterface,
  },
  {
    title: 'Spatial Awareness',
    description:
      'Treats physical space as an interface using position, orientation, movement, and real-time environmental understanding.',
    icon: iconsPath?.SpatialAwearness,
  },
  {
    title: 'Intelligent 3D Systems',
    description:
      'Continuously maps environments, anchoring digital content to real locations with contextual, responsive behavior.',
    icon: iconsPath?.ThreeDSystem,
  },
];

export const UsingSpatialGrid_2_1 = [
  {
    title: '1.  Spatial Grid Dashboard ',
    border: true,
  },
  {
    title: '2.  Projects & Workspaces',
    border: true,
  },
  {
    title: '3.  Grid Editor',
    border: true,
  },

  {
    title: '4.  Prompt Bar & Intelligent Controls',
    border: true,
  },

  {
    title: '5.  Asset Library & Reusable Components ',
    border: true,
  },

  {
    title: '6. Teams, Roles & Collaboration ',
    border: true,
  },
  {
    title: '7.Tutorials, Guides & In-Platform Learning',
    border: true,
  },
  {
    title: '8. Analytics & Experience Insights  ',
    border: true,
  },
  {
    title: '9. Notifications & Activity Monitoring ',
    border: true,
  },
  {
    title: 'See all 9 articles',
    icon: true,
    border: false,
    color: '#EE2B2A',
    path: '/help-center/using-spatialgrid-articles',
  },
];

export const RetailEcommerceFeaturesData = [
  {
    title: 'Visualize Products in Real Environments',
    description:
      'Enable shoppers to place true-to-scale products in their homes through AR, reducing uncertainty around fit, style, and functionality for faster, more confident purchases.',
    icon: iconsPath?.VisualizeProducts,
  },
  {
    title: 'Reduce Returns and Increase Satisfaction',
    description:
      'Immersive previews help customers understand products before buying, significantly lowering return rates and improving post-purchase confidence.',
    icon: iconsPath?.ReturnSatisfaction,
  },
  {
    title: 'Boost Engagement and Conversion',
    description:
      'Interactive 3D models, AR try-ons, and immersive storytelling increase engagement time, improve product understanding, and drive higher conversion rates.',
    icon: iconsPath?.EngagementConversion,
  },
  {
    title: 'Simplify Product Education Globally',
    description:
      'AI-driven guidance and multi-language support allow brands to deliver consistent, accessible product education across regions—helping customers learn quickly and accurately.',
    icon: iconsPath?.GlobalFacilities,
  },
  {
    title: 'Cut Marketing and Display Costs',
    description:
      'Reusable 3D assets and AR campaigns reduce reliance on expensive prototypes, photoshoots, and physical displays, lowering marketing spend while scaling across web, mobile, and in-store touchpoints.',
    icon: iconsPath?.LowerTraining,
  },
];

export const HealthcarePharmaFeaturesData = [
  {
    title: 'Practice Procedures in Safe, Realistic Simulations',
    description:
      'Immersive AR/MR environments allow clinicians and operators to rehearse complex procedures without risk—improving confidence, accuracy, and readiness before entering real clinical settings.',
    icon: iconsPath?.Realasticsimulation,
  },
  {
    title: 'Reduce Errors and Improve Compliance',
    description:
      'Interactive simulations reinforce SOPs, GMP workflows, and safety protocols, helping teams avoid mistakes, meet regulatory standards, and ensure consistent, compliant performance.',
    icon: iconsPath?.ErrorCompliance,
  },
  {
    title: 'Improve Retention and Skill Mastery',
    description:
      '3D anatomical models, medical device walkthroughs, and scenario-based training increase engagement and knowledge retention far beyond traditional classroom or manual-based learning.',
    icon: iconsPath?.RetentionMastery,
  },
  {
    title: 'Standardize Training Across Global Facilities',
    description:
      'AI-driven guidance and multi-language support deliver uniform training across sites, ensuring every team—whether in manufacturing, R&D, or clinical operations—receives the same high-quality instruction.',
    icon: iconsPath?.GlobalFacilities,
  },
  {
    title: 'Lower Training Costs and Protect Equipment',
    description:
      'Simulated learning eliminates equipment downtime, reduces reliance on senior instructors, and prevents wear on sensitive lab and manufacturing machinery—cutting overall training costs while improving efficiency.',
    icon: iconsPath?.LowerTraining,
  },
];

export const EducationTrainingFeaturesData = [
  {
    title: 'Learn Through Immersive, Hands-On Experiences',
    description:
      'AR/MR environments allow students and trainees to explore concepts in 3D, practice tasks interactively, and understand complex subjects through experiential learning—not just textbooks or lectures.',
    icon: iconsPath?.LearnImmersive,
  },
  {
    title: 'Improve Retention and Mastery',
    description:
      'Immersive learning boosts knowledge retention by placing learners inside realistic scenarios, helping them grasp concepts faster and remember them longer than with traditional methods.',
    icon: iconsPath?.ImproveRetention,
  },
  {
    title: 'Increase Engagement and Motivation',
    description:
      'Interactive simulations, spatial walkthroughs, and real-world challenges make learning more dynamic, improving participation, focus, and overall learner satisfaction.',
    icon: iconsPath?.IncreaseEngagement,
  },
  {
    title: 'Institutionalize Knowledge Across Classrooms ',
    description:
      'AI-driven guidance and multi-language support ensure every learner receives consistent, high-quality instruction—whether in schools, universities, or enterprise training programs.',
    icon: iconsPath?.KnoweledgeClassroom,
  },
  {
    title: 'Reduce Training Costs and Scale Efficiently',
    description:
      'Reusable 3D assets & immersive modules eliminate the need for physical models, equipment setups, or repeated instructor-led sessions—making it easier and more cost-effective to scale education across large groups.',
    icon: iconsPath?.TrainingCosts,
  },
];

export const TourismHospitalityFeaturesData = [
  {
    title: 'Immersive Virtual Tours & Cultural Exploration',
    description:
      'Visitors can explore historic sites, landmarks, festivals, and traditions through interactive 3D tours and AR storytelling that deepen understanding and inspire discovery.',
    icon: iconsPath?.ImmersiveVirtualTour,
  },
  {
    title: 'Location-Based Navigation & Guided AR Walks',
    description:
      'Guests receive real-time guidance through cities, resorts, museums, and attractions, with contextual information layered onto the real world for seamless, enriched exploration.',
    icon: iconsPath?.LocationBasedNavigation,
  },
  {
    title: 'Interactive Museums, Galleries & Wildlife Tours.',
    description:
      'AR/MR exhibits, virtual safaris, and touchpoint-led storytelling make cultural, artistic, and natural experiences more dynamic and engaging for all age groups.',
    icon: iconsPath?.InteractiveGalleries,
  },
  {
    title: 'Digital Preservation & Inclusive Accessibility',
    description:
      'Recreated heritage sites, multi-language support, and remote tours make destinations and cultural assets accessible to global audiences and guests with diverse needs.',
    icon: iconsPath?.DigitalPreservation,
  },
  {
    title: 'Enhanced Hospitality Experiences',
    description:
      'Hotels and resorts use immersive previews, guided property tours, and interactive concierge features to elevate guest engagement, streamline services, and showcase amenities more effectively.',
    icon: iconsPath?.EnhencedHospitality,
  },
];

export const ArchitectureRealStateFeaturesData = [
  {
    title: 'Visualize Properties in Real Environments',
    description:
      'AR and immersive 3D models let buyers place buildings, interiors, and layouts into their surroundings—reducing uncertainty and helping them understand scale, light, and space before construction begins.',
    icon: iconsPath?.PropertiesEnvironment,
  },
  {
    title: 'Increase Buyer Confidence and Reduce Drop-Offs',
    description:
      'Interactive walkthroughs, floor-plan visualizations, and real-time material changes give buyers a clearer understanding of design intent, leading to faster decisions and higher satisfaction.',
    icon: iconsPath?.ZeroRisk,
  },
  {
    title: 'Boost Engagement With Interactive Experiences',
    description:
      'Spatial walkthroughs, guided tours, and clickable hotspots bring projects to life, increasing time spent exploring and improving comprehension compared to static brochures or renders.',
    icon: iconsPath?.InteractiveExperience,
  },
  {
    title: 'Improve Collaboration Across Teams and Clients',
    description:
      'Immersive models make it easier for architects, developers, and clients to review designs, detect issues early, and align on choices—reducing revisions and miscommunication.',
    icon: iconsPath?.CollabrationClients,
  },
  {
    title: 'Reduce Marketing and Pre-Sales Costs',
    description:
      'Reusable 3D assets, virtual site tours, and AR promotions cut the need for physical mockups, show units, and repeated customer walkthroughs—scaling easily across digital and on-site channels.',
    icon: iconsPath?.TrainingPrototype,
  },
];

export const EnergyMiningFeaturesData = [
  {
    title: 'Train Workers in High-Risk Environments Safely',
    description:
      'Immersive simulations let teams practice hazardous tasks—such as equipment operation, confined space entry, and emergency response—without exposure to real-world danger.',
    icon: iconsPath?.ZeroRisk,
  },
  {
    title: 'Reduce Accidents and Strengthen Compliance',
    description:
      'Interactive spatial scenarios reinforce SOPs, safety protocols, and regulatory workflows, helping organizations minimize incidents and ensure consistent compliance across sites.',
    icon: iconsPath?.ErrorCompliance,
  },
  {
    title: 'Enhance Field Efficiency and Decision-Making',
    description:
      '3D spatial models, digital twins, and guided workflows help technicians visualize assets, understand procedures, and diagnose issues faster—improving accuracy and reducing downtime.',
    icon: iconsPath?.FeildDecision,
  },
  {
    title: 'Standardize Training Across Remote Sites',
    description:
      'AI-driven guidance and multi-language support deliver uniform training across mines, rigs, and processing facilities, ensuring all teams receive the same high-quality instruction regardless of location.',
    icon: iconsPath?.FleetsFacilities,
  },
  {
    title: 'Lower Operational and Training Costs',
    description:
      'Reusable immersive modules reduce reliance on on-site trainers, protect expensive machinery from misuse, & eliminate the need to halt operations for training—cutting overall costs & increasing uptime.',
    icon: iconsPath?.TrainingPrototype,
  },
];

export const AutomotiveFeaturesData = [
  {
    title: 'Visualize Vehicles and Systems in 3D',
    description:
      'Immersive models let teams explore engines, components, and transport systems at real scale—improving understanding of design, function, and maintenance workflows before touching real equipment.',
    icon: iconsPath?.VisualizeProducts,
  },
  {
    title: 'Reduce Errors and Improve Operational Safety',
    description:
      'Interactive simulations allow drivers, operators, and technicians to practice procedures, emergency scenarios, and high-risk tasks in a controlled environment, lowering incident rates & improving compliance.',
    icon: iconsPath?.ZeroRisk,
  },
  {
    title: 'Boost Engagement and Skill Mastery',
    description:
      'Hands-on walkthroughs, guided scenarios, and spatial demonstrations make complex processes easier to learn—helping teams grasp faster, retain longer, and perform with confidence.',
    icon: iconsPath?.RetentionMastery,
  },
  {
    title: 'Standardize Training Across Fleets and Facilities',
    description:
      'AI-driven guidance and multi-language support ensure consistent training quality across depots, service centers, and global teams, regardless of geography or equipment variations.',
    icon: iconsPath?.FleetsFacilities,
  },
  {
    title: 'Reduce Training and Prototype Costs',
    description:
      'Reusable immersive modules replace repeated instructor-led sessions, minimize wear on vehicles and machinery, and reduce reliance on physical prototypes—saving time and operational cost at scale.',
    icon: iconsPath?.TrainingPrototype,
  },
];

export const DefenceFeaturesData = [
  {
    icon: iconsPath?.MissileSimulation,
    title: 'Visualize Complex Systems',
    description:
      'Immersive spatial models let defence and space personnel explore aircraft, vehicles, satellites, sensors, weapons and mission systems at full scale—improving understanding before stepping into real operations.',
  },
  {
    icon: iconsPath?.ZeroRisk,
    title: 'Train for High-Risk Scenarios Safely',
    description:
      'Interactive simulations recreate emergency procedures, mission rehearsals, and threat environments, enabling teams to gain confidence and reduce errors without operational risk.',
  },
  {
    icon: iconsPath?.EngagementAwearness,
    title: 'Boost Engagement and Situational Awareness',
    description:
      'Hands-on simulations, spatial overlays, and guided mission walkthroughs help operators grasp complex workflows, improve reaction times, and enhance decision-making under pressure.',
  },
  {
    icon: iconsPath?.ImmersiveVirtualTour,
    title: 'Standardize Training Nationally Across Units',
    description:
      'AI-driven guidance and multi-language support ensure consistent, high-fidelity training across bases, spacecraft operations centers, and international teams—no matter the location or hardware.',
  },
  {
    icon: iconsPath?.CostsAssets,
    title: 'Cut Training Costs and Protect Critical Assets',
    description:
      'Reusable immersive modules reduce reliance on expensive mock-ups, minimize wear on aircraft and space systems, and remove the need for frequent live rehearsals—saving cost while improving readiness.',
  },
];

export const ManufacturingFeaturesData = [
  {
    title: 'Training employees don’t forget',
    description:
      'Spatial Grid’s immersive training gives employees hands-on practice inside realistic, simulated manufacturing environments. Interactive modules significantly boost retention compared to manuals, videos, or classroom instruction.',
    icon: iconsPath?.TrainingEmployee,
  },
  {
    title: 'Accurate performance insights, built in',
    description:
      'With Spatial Grid Analytics, every interaction is measurable. Track proficiency, compliance, error rates, and readiness—ensuring operators are skilled and production-ready.',
    icon: iconsPath?.AccuratePerformence,
  },
  {
    title: 'Zero risk to machinery or operations',
    description:
      'Enable employees to practice procedures without touching real machines, robots, or assembly lines. Prevent costly mistakes and keep production running uninterrupted.',
    icon: iconsPath?.ZeroRisk,
  },
  {
    title: 'Close the manufacturing skills gap',
    description:
      'As experienced workers retire, Spatial Grid accelerates knowledge transfer. Adaptive AI guidance and interactive simulations help new employees gain competence faster and more reliably.',
    icon: iconsPath?.ManufacturingSkill,
  },
  {
    title: 'Train global teams without language barriers',
    description:
      'Deploy consistent, high-quality training across all sites with built-in localization and multi-language support. Every worker receives the same immersive, effective learning—no matter where they are.',
    icon: iconsPath?.GlobalTeam,
  },
];